import moment from "moment";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

/**
 * Exports JSON data to an Excel file with given column mapping and file name.
 * @param data Array of rows (objects)
 * @param visibleColumns Columns array from DataGrid with visibility applied
 * @param fileName Excel file name without extension
 */
export const exportDataToExcel = (data: any[], visibleColumns: any[], fileName: string) => {
    if (!data || data.length === 0) {
    toast.info("No results to export.");
    return;
    }

    // Filter only visible columns
    const columnsToExport = visibleColumns;

    // Map data to visible columns only
    const mappedData = data.map(row => {
    const formattedRow: any = {};
    columnsToExport.forEach(col => {
        const field = col.field;
        const value = row[field]; 

        if (col.type === "date" || col.type === "dateTime") {
            if (!value) {
                formattedRow[col.headerName || field] = "";
                return;
            }
            // ✅ Keep same format as grid (as plain text)
            formattedRow[col.headerName || field] = moment
            .utc(value)
            .local()
            .format("M/DD/YYYY hh:mm A");
        } 
        else {
            formattedRow[col.headerName || field] = value;
        }
    });
    return formattedRow;
    });

    // Create worksheet & workbook
    const worksheet = XLSX.utils.json_to_sheet(mappedData, {cellDates: false});
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");

    // Generate file name
    const formattedDate = moment().format("YYYYMMDD_HHmmss");
    const finalFileName = `${fileName}_${formattedDate}.xlsx`;

    XLSX.writeFile(workbook, finalFileName);
};
